import type { Asset, Concept, ViewId } from "@storytell/types";
import type { FilterBuilder } from "../filtering/filterBuilder";
import { StButton } from "@storytell/ui/buttons";
import dayjs from "dayjs";
import { TbBook, TbStack } from "solid-icons/tb";
import { For, type Setter } from "solid-js";
import { twMerge } from "tailwind-merge";
import { useWire } from "~/wire";
import { TbStackPlus } from "./TbStackPlus";
import type { EntitySelection } from "./useEntitySelection";

export const KnowledgePaneViews = (props: {
  filterBuilder: FilterBuilder<Asset | Concept>;
  assetsSelection: EntitySelection;
  conceptsSelection: EntitySelection;
  hasViewChanges: boolean;

  editView: boolean;
  setEditView: Setter<boolean>;
}) => {
  const wire = useWire();
  const { sync: s, knowledgeUi } = wire;
  const isActive = (id: "all" | ViewId | "new") => knowledgeUi.activeView() === id;

  return (
    <>
      <For
        each={[
          { id: "all", name: "All Knowledge" } as const,
          ...s.views
            .search("")
            .sort((a, b) => dayjs(b.modifiedAt || b.createdAt).diff(dayjs(a.modifiedAt || a.createdAt))),
        ]}
      >
        {(view) => (
          <StButton
            data-active={isActive(view.id)}
            iconClass="size-5"
            onClick={() => knowledgeUi.setActiveView(view.id)}
            noColor={isActive(view.id)}
            icon={view.id === "all" ? TbBook : TbStack}
            class={twMerge(
              "py-0.5 dark:border-primary-border shrink-0",
              isActive(view.id) && "bg-brand hover:bg-brand-hover text-on-brand",
            )}
          >
            {view.name}
          </StButton>
        )}
      </For>

      <StButton
        data-active={isActive("new")}
        icon={TbStackPlus}
        iconClass="size-5"
        noBorder
        noColor
        onClick={() => {
          knowledgeUi.setActiveView("new");
        }}
        class={twMerge(
          "py-0.5 dark:border-primary-border shrink-0 sticky right-0",
          isActive("new") && "bg-brand hover:bg-brand-hover text-on-brand",
        )}
      >
        New View
      </StButton>
    </>
  );
};
